// src/utils/resolvePermissionByPath.js
export const resolvePermissionByPath = (menuItems, pathname) => {
    for (const item of menuItems) {
        // Exact or prefix match
        if (item.path && pathname.startsWith(item.path)) {
            return item.permission || null;
        }

        if (item.children) {
            const childPermission = resolvePermissionByPath(
                item.children,
                pathname
            );
            if (childPermission) return childPermission;
        }
    }
    return null;
};



// 🚀 Resolve FIRST path user is allowed to access
export const resolveFirstAllowedPath = (menuItems, userPermissions) => {
    if (!Array.isArray(menuItems) || !Array.isArray(userPermissions)) {
        return null;
    }

    for (const item of menuItems) {
        // Direct menu
        if (
            item.path &&
            item.permission &&
            userPermissions.includes(item.permission)
        ) {
            return item.path;
        }

        // Child menu
        if (item.children?.length) {
            for (const child of item.children) {
                if (
                    child.path &&
                    child.permission &&
                    userPermissions.includes(child.permission)
                ) {
                    return child.path;
                }
            }
        }
    }

    return null;
};